import { IAppealFormProps } from "../../model/interface";
import { AppealType } from "../../model/enum";
import AccountAppealForm from "./AccountAppealForm";
import ContentAppealForm from "./ContentAppealForm";
import React from "react";

export default function AppealForm(props: IAppealFormProps) {

    return (
        <React.Fragment>
            {(props.appealType === AppealType.Account) &&
                <AccountAppealForm
                    currentFormInfo={props.formInfo}
                    userIdChange={props.userIdChange} />
            }
            {(props.appealType === AppealType.Content) &&
                <ContentAppealForm
                    currentFormInfo={props.formInfo}
                    appealerName={props.formInfo?.appealerName}
                    contactEmail={props.formInfo?.contactEmail}
                    policyViolation={props.formInfo?.policyViolated}
                    product={props.formInfo?.product}
                    nameChange={props.nameChange}
                    emailChange={props.emailChange}
                />
            }
        </React.Fragment>
    )
}